import axios from "axios";
import apiUrl from "./api";
import { toast } from "react-toast";


/*
@@ auther Vishal Lohbande
created date: 05-02-2025
function Name: getUserList
parameters: ( key, type, status, page, size )
desc: fetch all the user details list
*/
async function getUserList(key, type, status, page, size) {
    const token = window.localStorage.getItem('token');
    const requestBody = {
        "key": key.trim(),
        "type": type,
        "status": status
    }
    try {
        const response = await axios.post(`${apiUrl}secure/user/retain-all-users?page=${page}&size=${size}`, requestBody, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });

        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response;
    }
}


/*
@@ auther Vishal Lohbande
created date: 05-02-2025
function Name: getUserCounts
parameters: (  )
desc: fetch all the user details list
*/
async function getUserCounts() {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/retain-all-users-info`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response
    }
}

/*
@@ auther Vishal Lohbande
created date: 05-02-2025
function Name: getUserPersonalDetails
parameters: (  )
desc: fetch personal details of user.
*/
async function getUserPersonalDetails(id) {
    const token = window.localStorage.getItem('token');
    localStorage.removeItem('userPersonalDetails');

    try {
        const response = await axios.get(`${apiUrl}secure/user/${id}/retain-single-user-personal-details`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        localStorage.setItem('userPersonalDetails', JSON.stringify(response?.data?.data));
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response
    }
}

/*
@@ auther Vishal Lohbande
created date: 06-02-2025
function Name: getUserPersonalDetails
parameters: (  )
desc: fetch wallet details of user.
*/
async function getUserWalletDetails(userId) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/${userId}/retain-single-user-wallet-details`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        switch (error.request.status) {
            case 401:
                toast.error('login please', { autoClose: 2000 })
                // setRouteStatus('/login')
                break
            default:
                return
        }
        return error.response
    }
}


/*
@@ auther Vishal Lohbande
created date: 06-02-2025
function Name: getUserPoolsDetails
parameters: (  )
desc: fetch pools details of user.
*/
async function getUserPoolsDetails(userId) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/${userId}/retain-single-user-personal-details`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response;
    }
}


/*
@@ auther Vishal Lohbande
created date: 06-02-2025
function Name: getUserPoolsDetails
parameters: (  )
desc: fetch pools details of user.
*/
async function getUserUpdateDetails(requestsParam) {
    const token = window.localStorage.getItem('token');
    const userData = JSON.parse(localStorage.getItem('userData'));

    const formData = new FormData();

    for (const key in requestsParam) {
        if (requestsParam.hasOwnProperty(key)) {
            if (key === 'userImageFile' && requestsParam[key]) {
                const file = requestsParam[key];
                const fileName = file.name || `user-image-${Date.now()}.png`;
                formData.append("userImageFile", file, fileName);
            } else {
                formData.append(key, requestsParam[key]);
            }
        }
    }

    // if (requetsParam?.userImageFile) {
    //     formData.append("userImageFile", requetsParam.userImageFile, fileName);
    // }
    try {
        const response = await axios.put(`${apiUrl}secure/user/update-user`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
                'X-User-Id': `${userData?.userId}`
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response;;
    }
}

/*
@@auther Govind Dindewad
created date: 06-03-2025
function Name: getUserPlatforms
parameters: (  )
desc: fetch all the user's platform and pools info as a list
*/
async function getUserPlatforms(userID, page) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/${userID}/retain-single-user-platform-details?page=${page}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response;
    }
}
async function getUserTransactionDetails(userID, startDate, endDate) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/${userID}/retain-single-user-transactions?startDate=${startDate}&endDate=${endDate}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response;
    }
}

async function userLogout(userID, deviceType) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/logout`, {
            headers: {
                'Authorization': `Bearer ${token}`,
                "X-User-Id": userID,
                "X-Device-Type": deviceType
            }
        });
        return response;

    } catch (error) {
        return error.response;
    }
}

/*
@@auther Govind Dindewad
created date: 05-05-2025
function Name: getAllEmployees
parameters: ( page )
desc: fetch all employees for role management in dashboard
*/
async function getAllEmployees(key, page, size) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/retain-employee-users?page=${page}&size=${size}&key=${key}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }

        return error.response;
    }
}

/*
@@auther Govind Dindewad
created date: 05-05-2025
function Name: getAllEmployees
parameters: ( page )
desc: fetch all employees for role management in dashboard
*/
async function searchUserExceptEmployee(key) {
    const token = window.localStorage.getItem('token');
    try {
        const response = await axios.get(`${apiUrl}secure/user/search-users?key=${key}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response;
    }
}


/*
@@ auther Govind Dindewad
created date: 06-05-2025
function Name: updateUserRole
parameters: ( obj )
desc: update role of employee.
*/
async function updateUserRole(requetsParam) {
    const token = window.localStorage.getItem('token');
    const userData = JSON.parse(localStorage.getItem('userData'));
    const formData = new FormData();
    formData.append("userId", requetsParam?.userId);
    formData.append("userRole", requetsParam?.userRole);

    try {
        const response = await axios.put(`${apiUrl}secure/user/update-user`, formData, {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
                'X-User-Id': `${userData?.userId}`
            }
        });
        return response;

    } catch (error) {
        if (error?.message === 'Network Error') {
            return {
                status: 301,
                message: 'Network Error'
            }
        }
        return error.response;;
    }
}


export { getUserList, getUserCounts, getUserPersonalDetails, getUserWalletDetails, getUserPoolsDetails, getUserUpdateDetails, getUserPlatforms, getUserTransactionDetails, userLogout, getAllEmployees, searchUserExceptEmployee, updateUserRole };